'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/MAGNET.png'
import ServiceDetailsImg1 from '../../assets/images/services/heavy-duty-scrap-shear.png'
import ServiceDetailsImg2 from '../../assets/images/services/vertical-scrap-shear.png'
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, Thumbs } from 'swiper/modules';
import table, { Table } from 'react-bootstrap'
import SEOHelmet from '../../components/SEO/SEOHelmet';
import VideoOne from '../home-3/VideoOne';
// import ModalVideo from 'react-modal-video';
// import 'react-modal-video/css/modal-video.min.css';
const mainSlider = {
    width: '90%',
}




const VerticalShear = () => {
    const images = [
        {
            original: ServiceDetailsImg1,
            thumbnail: ServiceDetailsImg1,
            originalAlt: "Slide 1",
            thumbnailAlt: "Thumbnail 1",
        },
        {
            original: ServiceDetailsImg2,
            thumbnail: ServiceDetailsImg2,
            originalAlt: "Slide 2",
            thumbnailAlt: "Thumbnail 2",
        }

    ]

    // State to hold dynamic content
    const [projectInfo] = useState({
        category: "Roof Service",
        customer: "David Bravis",
        startDate: "21 April 2024",
        endDate: "28 September 2024",
        rating: 5,
    });
    const [socialLinks] = useState([
        { href: "https://www.facebook.com/profile.php?id=61573443062800", iconClass: "icon-facebook-f" },
        { href: "https://x.com/design79356", iconClass: "icon-Vector" },
        { href: "https://www.instagram.com/ramanasteels/", iconClass: "icon-instagram" },
        { href: "https://in.pinterest.com/Ramanasteels/", iconClass: "icon-pinterest" },
    ]);
    const [serviceDetails] = useState({

        // text1: "Horizontal Automatic Container Shear is ideal for cutting the metal shaped in different cross sections like round, square, channel, angle, I shape, plate and various waste structural metal at cold state. It brings convenience to the baling, storage and transportation of scrap metal materials, and also offers qualified furnace charges for smelting plants.",
        image1: ServiceDetailsImg,
        title: "Vertical Heavy Duty Scrap Shearing Machine",
        text2: "Heavy-duty scrap shearing machine is a dynamic and heavy duty multi-tasking machine. It can be used to achieve multiple tasks such as cutting various low-carbon, light and thin production, scrap automobile shear, light metal structures, domestic scrap steel, light metal structural large parts, profiles made up of steel that confirms to furnace charge.This machine is the most beneficial for steel mills, non-ferrous metal smelting industries, precision casting and raw material manufacturers.",
        points: [
            "The machine adopts a large feeding mouth along with a large, wide material box design, so it naturally adapts to scrap raw materials and high scrap density after shearing.",
            "The machine is easy to use, cost-efficient and convenient for operational use. It also supports mechanical, electrical and hydraulic integrated controls. In addition to this, it adopts imported PLC control, with a high level of reliability and very simple maintenance.",
            "All the moving parts are hydraulically driven, with stable operation with a large shear force and high level of efficiency.",


        ]
    });

    return (
        <React.Fragment>
            <SEOHelmet 
                title="Vertical Heavy-Duty Scrap Shearing Machine"
                description="Dynamic multi-tasking scrap shearing machine for cutting low-carbon, light metals, and structural steel. Ideal for steel mills and precision casting industries."
                keywords="vertical shear, scrap shearing machine, heavy-duty shear, metal cutting, industrial shearing"
                canonicalUrl="https://ramanasteels.com/vertical-scrap-shear"
            />

            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">

                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="justify-content-center mt-4">
                                        <div className="card p-3 rounded" style={mainSlider}>
                                            <ImageGallery
                                                items={images}
                                                showPlayButton={false}
                                                showFullscreenButton={true}
                                                showThumbnails={true}
                                                autoPlay={true}
                                                slideInterval={4000}
                                                showNav={true}
                                                additionalClass="img-slider"
                                            />
                                        </div>
                                    </div>
                                    <h1 className="service-details__title-one">{serviceDetails.title}</h1>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>
                                    <VideoOne videoId={"XgZwiSBKLqs"} />
                                    <ul className="list-unstyled service-details__points">
                                        <h3>Features</h3>
                                        {serviceDetails.points.map((point, index) => (
                                            <li key={index}>
                                                <div className="icon">
                                                    <i className="far fa-check" />
                                                </div>
                                                <div className="text">
                                                    <p>{point}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div>
                                    <Table responsive>
                                        <thead style={{ color: '#FFFFFF', background: '#2F8CD6' }}><tr> <th>Model  </th>
                                            <th>Max Cutting Force</th>
                                            <th>Blade Width</th>
                                            <th>Workbin Length X Breadth </th>
                                            <th>Motor </th>
                                        </tr></thead>
                                        <tbody>
                                            <tr>
                                                <td>Q91Y-630T</td>
                                                <td>630</td>
                                                <td>1800</td>
                                                <td>7000x1750</td>
                                                <td>45KWx3</td>
                                            </tr>
                                            <tr>
                                                <td>Q91Y-800T</td>
                                                <td>800</td>
                                                <td>2000</td>
                                                <td>8000x1750</td>
                                                <td>45KWx4</td>
                                            </tr>
                                            <tr>
                                                <td>Q91Y-1000T</td>
                                                <td>1000</td>
                                                <td>2000</td>
                                                <td>8000x1950</td>
                                                <td>45KWx4</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="project-details__sidebar">
                                <div className="project-details__project-info">
                                    <h3 className="project-details__project-info-title">
                                        Product Information
                                    </h3>
                                    <ul className="list-unstyled project-details__project-info-list">
                                        <li>
                                            <h5>Origin:</h5>
                                            <h5>China{/* {projectInfo.category} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Make:</h5>
                                            <h5>Gaode{/* {projectInfo.customer} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Used In:</h5>
                                            <h5> Heavy duty scrap<br /> processing{/* {projectInfo.startDate} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Rating:</h5>
                                            <div className="rating">
                                                {Array(projectInfo.rating)
                                                    .fill(0)
                                                    .map((_, index) => (
                                                        <span className="icon-star" key={index}></span>
                                                    ))}
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="project-details__social">
                                        {socialLinks.map((link, index) => (
                                            <Link to={link.href} key={index}>
                                                <span className={link.iconClass}></span>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="project-details__need-help">
                                {/* <div className="project-details__need-help-img">
                                    <img
                                        src="/assets/images/project/project-details-need-help-img.jpg"
                                        alt="Need Help"
                                    />
                                </div> */}
                                <div className="project-details__need-help-icon">
                                    <span className="icon-call"></span>
                                </div>
                                <p className="project-details__need-help-sub-title">
                                    Contact Us
                                </p>
                                <h3 className="project-details__need-help-number">
                                    <Link to="tel:+91-9815902561"> +91-9815902561</Link>
                                </h3>
                            </div>
                            {/* <div className="project-details__download">
                                <ul className="project-details__download-list list-unstyled">
                                    <li>
                                        <Link to="#">
                                            <span>Company File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <span>Project File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                </ul>
                            </div> */}
                        </div>

                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default VerticalShear;


